// extracted by mini-css-extract-plugin
export default {"error_content":"Errors_error_content__kwqlH","row":"Errors_row__SWRa7","btn":"Errors_btn__94H5E"};